/* Copyright (c) 2020 IceRock MAG Inc. Use of this source code is governed by the Apache 2.0 license. */

import React, { FC, useCallback, useMemo } from 'react';
import { DatePicker } from '@material-ui/pickers';
import format from 'date-fns/format';
import parseISO from 'date-fns/parseISO';
import { TextField } from '@material-ui/core';
import { formatISO, isValid } from 'date-fns';
import {IEntityFieldProps} from "icerockdev-admin-toolkit";

type IProps = IEntityFieldProps & {};

const EntityFieldDate: FC<IProps> = ({
  value,
  handler,
  label,
  error,
  isEditing,
  onClick,
}) => {
  const onChange = useCallback(
    (value) => {
      if (!value || !handler || !isValid(value)) return;
      const year = value.getFullYear();
      const month = String(value.getMonth() + 1).padStart(2, '0');
      const day = String(value.getDate()).padStart(2, '0');
      handler(year+ "-" + month + "-" + day);
    },
    [value, handler]
  );

  const parsedValue = useMemo(() => {
    const date = parseISO(value);

    return (date && isValid(date) && formatISO(date)) || null;
  }, [value]);

  return isEditing ? (
    <div className="datepicker datepicker_date">
      <DatePicker
        renderInput={(props) => (
          <TextField
            variant="outlined"
            {...props}
            label={label}
            helperText=""
          />
        )}
        value={parsedValue}
        onChange={onChange}
      />
    </div>
  ) : (
    <div onClick={onClick}>
      {parsedValue ? (
        format(parseISO(parsedValue), 'dd.MM.yyyy')
      ) : (
        <div>&nbsp;</div>
      )}
    </div>
  );
};

export { EntityFieldDate };
